import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class EmployeesAssigned extends Column {
    title = 'time-tracking.indexProjectsPage.table.employeesAssigned';
    property = 'assignmentsCount';
    type: CellDisplay = CellDisplay.string;
}
